import React from 'react';
import { NavLink } from 'react-router-dom';

const Header = (props) => {
  let location = props.props.match.path.slice(1).split('/')[0];
  let secondLocation = props.props.match.path.slice(1).split('/')[1];
    return (
    <div>
      { secondLocation ? (
        <div className={secondLocation.length ? `${secondLocation}-header` : `main-header`}>
          <nav className="header-effect">
            <NavLink to="/" >
              { !location.length ? (
                <div style={{color: 'white'}}>
                  Home
                </div>
              ) : (
              <span data-hover="Home">
                Home
              </span>
              )}
            </NavLink>
          </nav>
          <nav className="header-effect">
            <NavLink to="/design">
              { location === 'design' ? (
                <div style={{color:'white'}}>
                  <u>Projects</u>
                </div>
              ) : (
              <span data-hover="Projects">
                Projects
              </span>
              )}
            </NavLink>
          </nav>
          <nav className="header-effect">
            <NavLink to="/artwork" >
              { location === 'artwork' ? (
                <React.Fragment>
                  { secondLocation === 'complicity' || secondLocation === 'moto' || secondLocation === 'bigheads'?
                  <div style={{color: 'black'}}>
                    <u>Artwork</u>
                  </div>
                  :
                  <div style={{color:'white'}}>
                    Artwork
                  </div>
                  }
                </React.Fragment>
              ) : (
              <span data-hover="Artwork">
                Artwork
              </span>
              )}
            </NavLink>
          </nav>
          <nav className="header-effect">
            <NavLink to="/bio">
              { location === 'bio' ? (
                <div style={{color: 'white'}}>
                  About
                </div>
              ) : (
              <span data-hover="About">
                About
              </span>
              )}
            </NavLink>
          </nav>
            <React.Fragment>
            { secondLocation === 'complicity' || secondLocation === 'moto' || secondLocation === 'bigheads' ? (
              <div style={{color: 'black'}}>
              |
              </div>
            ) : (
              <div style={{color: 'white'}}>
              |
              </div>
            )}
           </React.Fragment>
          <nav className="header-effect">
            <NavLink to="/other">
              { location === 'other' ? (
                <div style={{color: 'white'}}>
                  Other
                </div>
              ) : (
              <span data-hover="Other">
                Other
              </span>
              )}
            </NavLink>
          </nav>
        </div>
      ) : (
      <div className={location.length ? `${location}-header` : `main-header`}>
        <nav className="header-effect">
          <NavLink to="/" >
            { !location.length ? (
              <div style={{color: 'white'}}>
                Home
              </div>
            ) : (
            <span data-hover="Home">
              Home
            </span>
            )}
          </NavLink>
        </nav>
        <nav className="header-effect">
          <NavLink to="/design">
            { location === 'design' ? (
              <div style={{color: 'white'}}>
                Projects
              </div>
            ) : (
            <span data-hover="Projects">
              Projects
            </span>
            )}
          </NavLink>
        </nav>
        <nav className="header-effect">
          <NavLink to="/artwork" >
            { location === 'artwork' ? (
              <div style={{color: 'white'}}>
                Artwork
              </div>
            ) : (
            <span data-hover="Artwork">
              Artwork
            </span>
            )}
          </NavLink>
        </nav>
        <nav className="header-effect">
          <NavLink to="/bio">
            { location === 'bio' ? (
              <div style={{color: 'white'}}>
                About
              </div>
            ) : (
            <span data-hover="About">
              About
            </span>
            )}
          </NavLink>
        </nav>
        <div style={{color: 'white'}}>
          |
        </div>
        <nav className="header-effect">
          <NavLink to="/other">
            { location === 'other' ? (
              <div style={{color: 'black'}}>
                Other
              </div>
            ) : (
            <span data-hover="other">
              Other
            </span>
            )}
          </NavLink>
        </nav>
      </div>
    )}
    </div>
    );
}

export default Header;






